const COOKIE_DEFAULT = 'nedaware_cmp';
const MAX_AGE = 60 * 60 * 24 * 365 * 2;

export class Storage {
  constructor(opts = {}) {
    this.cookieName = opts.cookieName ?? COOKIE_DEFAULT;
    this.cookieDomain = opts.cookieDomain ?? '';
  }

  write(payload) {
    const json = JSON.stringify(payload);
    try {
      const dom = this.cookieDomain ? `; domain=${this.cookieDomain}` : '';
      document.cookie = `${this.cookieName}=${encodeURIComponent(json)}; max-age=${MAX_AGE}; path=/; secure; samesite=lax${dom}`;
    } catch (e) {}
    try { localStorage.setItem(this.cookieName, json); } catch (e) {}
  }

  read() {
    const fromCookie = this._readCookie();
    if (fromCookie) return fromCookie;
    try {
      const raw = localStorage.getItem(this.cookieName);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  _readCookie() {
    try {
      const m = document.cookie.match(new RegExp('(?:^|; )' + this.cookieName + '=([^;]*)'));
      return m ? JSON.parse(decodeURIComponent(m[1])) : null;
    } catch (e) { return null; }
  }

  clear() {
    try {
      const dom = this.cookieDomain ? `; domain=${this.cookieDomain}` : '';
      document.cookie = `${this.cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${dom}`;
    } catch (e) {}
    try { localStorage.removeItem(this.cookieName); } catch (e) {}
  }
}
